import { DashboardEndpoints } from "../api/admin/dashboard.endpoints";
import APIrequest from "../lib/axios"

export const DashboardService = {
    async getOverview() {
        try {
            const payload = {
                ...DashboardEndpoints.getOverview,
            }
            const response = await APIrequest(payload);
            return response.data
        } catch (error) {
            throw error;
        }
    }
}
